import { useState } from "react";
import { Link } from "react-router-dom";

function Project({ prData, placementCard }) {
  const MAX = 6;
  const [isCollapse, expended] = useState(prData.skills.length < MAX);

  const handleToExpend = () => {
    expended(!isCollapse);
  };
  return (
    <div
      className="card mb-5 p-4 rounded-3  overflow-hidden"
      data-aos="fade-up"
    >
      <div
        className={`row g-4  g-md-0 justify-content-between align-items-center ${placementCard}`}
      >
        <div className="col-md-6 scale-effect img-animation rounded-3">
          <Link to={`project/${prData.route}`}>
            <img
              loading="lazy"
              src={prData.img}
              className="live-demo img-fluid  rounded-start rounded-3 border border-1"
              alt="..."
              databstoggle="tooltip"
              databsplacement="bottom"
              databstitle="It may takes a few seconds to display due to server issues."
              databscustomclassname="custom-tooltip"
              dataaos="fade-up"
            />
          </Link>
        </div>
        <div className="col-md-5 d-flex align-items-center ">
          <div className="card-body p-0">
            <h5 className="card-title mb-4 text-center " data-aos="fade-up">
              <span className="fw-bold  text-uppercase fs-4">
                {prData.title.toUpperCase()}
              </span>
              <br></br>
              <small className="fs-6">({prData.finishPr})</small>
            </h5>
            <p className="card-text text-center" data-aos="fade-up">
              {prData.desc}
            </p>
            {/* <div
              className={`d-flex justify-content-center gap-4 flex-wrap ${
                isCollapse ? "" : ""
              }`}
            > */}
            {isCollapse ? (
              <>
                <div
                  className={`d-flex justify-content-center gap-4 flex-wrap ${
                    isCollapse ? "" : ""
                  }`}
                >
                  {prData.skills.map((skill, index) => (
                    <span
                      className="p-3 py-2 rounded-2 fw-semibold  border border-1"
                      key={index}
                      data-aos="fade-up"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
                {prData.skills.length > MAX ? (
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <button
                      onClick={handleToExpend}
                      className="btn btn-sm custom-btn d-flex align-items-center  gap-2"
                      data-aos="fade-up"
                    >
                      See Less
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        class="bi bi-chevron-up"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                        />
                      </svg>
                    </button>
                  </div>
                ) : null}
              </>
            ) : (
              <>
                <div
                  className={`d-flex justify-content-center gap-4 flex-wrap ${
                    isCollapse ? "" : ""
                  }`}
                >
                  {prData.skills.map((skill, index) =>
                    index < MAX ? (
                      <span
                        className="p-3 py-2 rounded-2 fw-semibold  border border-1"
                        key={index}
                        data-aos="fade-up"
                      >
                        {skill}
                      </span>
                    ) : null
                  )}
                </div>
                {prData.skills.length > MAX ? (
                  <div className="d-flex justify-content-center align-items-center mt-4">
                    <button
                      onClick={handleToExpend}
                      className="btn btn-sm custom-btn  d-flex align-items-center  gap-2"
                      data-aos="fade-up"
                    >
                      See All
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="14"
                        fill="currentColor"
                        class="bi bi-chevron-down"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                        />
                      </svg>
                    </button>
                  </div>
                ) : null}
              </>
            )}
            {/* </div> */}
            <div className="d-flex justify-content-center mt-4  gap-5">
              <a
                href={prData.linkDemo}
                className="text-decoration-none d-flex align-items-center gap-2 special-hover-color text-danger"
                style={{ cursor: "not-allowed" }}
                rel="noreferrer"
                data-aos="fade-up"
              >
                <span className="fw-medium ">Exclusive Code</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="tabler-icon tabler-icon-brand-github"
                >
                  <path d="M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"></path>
                </svg>
              </a>
              <Link
                to={`project/${prData.route}`}
                className="live-demo text-decoration-none d-flex align-items-center gap-2 special-hover-color"
                databstoggle="tooltip"
                databstitle="It may takes a few seconds to display"
                databscustomclassname="custom-tooltip"
                data-aos="fade-up"
              >
                <span className="fw-medium ">Live Demo</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="tabler-icon tabler-icon-external-link"
                >
                  <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6"></path>
                  <path d="M11 13l9 -9"></path>
                  <path d="M15 4h5v5"></path>
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Project;
